/**
 * What the signed-in host operator may do, read once per host session so the rail and the pages offer
 * only what the server would allow. The server re-checks every action, so this is a courtesy, never
 * the rule: a permission taken away while the page is open still refuses the next click.
 */
import { HostPermission, type HostUserDto } from '../contracts.gen.js';
import { myAccess } from './host.js';

let access: HostUserDto | null = null;
let loaded = false;
const listeners = new Set<() => void>();

export async function load(): Promise<void> {
  try {
    access = await myAccess();
  } catch {
    access = null;
  }
  loaded = true;
  for (const fn of listeners) fn();
}

export function reset(): void {
  access = null;
  loaded = false;
}

/** False until loaded: a rail entry appearing a moment late is better than one that is refused. */
export function has(permission: HostPermission): boolean {
  return access !== null && !access.disabled && (access.permissions & permission) === permission;
}

export function isLoaded(): boolean {
  return loaded;
}

export function current(): HostUserDto | null {
  return access;
}

export function onChanged(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export { HostPermission };
